<div class="filter">
    <h3 class="filter-title">{{title}}</h3>
    <ng-content></ng-content>
    <div *ngIf="!hideButton" class="col-12 p-0">
        <div class="flex align-items-center justify-content-end">
            <p-button label="Buscar" (click)="onSearch()" class=""></p-button>
        </div>
    </div>
</div>
